import React, { useState } from "react";

import { images } from "../../../../../assets/images";
import { InfoModalButtonContainer } from "./info-modal-style";

interface InfoModalButtonProps {
  buttonText: string;
  children: React.ReactNode;
}

const InfoModalButton = ({ buttonText, children }: InfoModalButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <InfoModalButtonContainer>
      <button className="button-link" onClick={() => setIsModalOpen(true)}>
        <span className="button-link-image">
          <img src={images.IconInfoBlue} alt="icono de información" />
        </span>
        {buttonText}
      </button>

      <div className={`modal-mask ${isModalOpen ? "show-modal" : ""}`}>
        <div className="modal-backdrop" onClick={() => setIsModalOpen(false)} />
        <div className="modal-content">
          <div className="modal-btn-container">
            <button className="modal-close-btn" onClick={() => setIsModalOpen(false)}>
              <img src={images.IconCloseGrey} alt="Icono de cierre" />
            </button>
          </div>
          {children}
        </div>
      </div>
    </InfoModalButtonContainer>
  );
};

export default InfoModalButton;
